module.exports = __webpack_public_path__ + "img/side-online.5f4b8d5a.png";